import React, { Component } from "react";
import PropTypes from "prop-types";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { injectIntl, FormattedMessage } from "react-intl";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import cx from "classnames";
import FormGroup from "react-bootstrap/lib/FormGroup";
import ControlLabel from "react-bootstrap/lib/ControlLabel";

import FooterButton from "./FooterButton";
import SidePanel from "./SidePanel";
import InputFieldComponent from "../Common/FormField/InputFieldComponent";

import validateStep2 from "./validateStep2";
import updateStep2 from "./updateStep2";
import messages from "../../locale/messages";

import s from "./ListPlaceStep1.css";
import bt from "../../components/commonStyle.css";
import PhotoInstuctionIcon from "/public/SiteImages/instructionPhotoNew.svg";

import DropzoneComponent from "react-dropzone-component";
// import documentIcon from "/public/SiteIcons/documentUpload.svg";
import showToaster from "../../helpers/showToaster";
import documentIcon from "/public/SiteIcons/photoUpload.svg";
class Description extends Component {
  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
      chars_left: 250,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  componentDidMount() {
    const { title } = this.props;
    let max_chars = title ? 250 - title.length : 250;
    this.setState({
      chars_left: max_chars,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid } = nextProps;
    const { title } = nextProps;
    let max_chars = title ? 250 - title.length : 250;
    this.setState({
      chars_left: max_chars,
    });
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  handleChange(event) {
    var input = event.target.value;
    let max_chars = 250;
    this.setState({
      chars_left: max_chars - input.length,
    });
  }

  render() {
    const { handleSubmit, previousPage, formPage, step } = this.props;
    const { formatMessage } = this.props.intl;
    const { isDisabled, chars_left } = this.state;

    return (
      <div className={s.grid}>
        <SidePanel
          title={formatMessage(messages.stepTwoCommonHeading)}
          landingContent={formatMessage(messages.placeTitlePanel)}
        />
        <form onSubmit={handleSubmit}>
          <div className={s.landingMainContent}>
            <FormGroup className={s.space5}>
              <ControlLabel className={cx(s.landingLabel, "textWhite")}>
                <FormattedMessage {...messages.placeTitle} />
              </ControlLabel>
              <Field
                name="title"
                type="text"
                component={InputFieldComponent}
                placeholder={formatMessage(messages.titleLabel)}
                inputClass={cx(s.formControlInput, s.jumboInput)}
                onChange={this.handleChange}
                chars_left={chars_left}
              />
            </FormGroup>
            <FormGroup className={s.space5}>
              <ControlLabel className={cx(s.landingLabel, "textWhite")}>
                <FormattedMessage {...messages.description} />
              </ControlLabel>
              <Field
                name="description"
                component={InputFieldComponent}
                componentClass="textarea"
                inputClass={s.textareaInput}
                placeholder={formatMessage(messages.descriptionLabel)}
              />
            </FormGroup>
            <FormGroup className={s.space5}>
              <ControlLabel className={cx(s.landingLabel, "textWhite")}>
                <FormattedMessage {...messages.captionTitleList} />
              </ControlLabel>
              <Field
                name="captionTitle"
                type="text"
                component={InputFieldComponent}
                placeholder={formatMessage(messages.captionTitleList)}
                inputClass={cx(s.formControlInput, s.jumboInput)}
              />
            </FormGroup>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                marginBottom: "10px",
                fontSize: "16px",
                fontWeight: "500",
                color: "var(--menu-color)",
              }}
            >
              <img
                src={PhotoInstuctionIcon}
                alt="Instruction Icon"
                style={{ width: "24px", height: "24px" }}
              />
              <FormattedMessage {...messages.photoInstruction} />
            </div>
            <ul style={{ paddingLeft: "20px", color: "var(--menu-color)" }}>
              <li>
                <FormattedMessage {...messages.photoInstructionOne} />
              </li>
              <li>
                <FormattedMessage {...messages.maxCoverSize} />
              </li>

            </ul>
            <FormGroup className={s.space5}>
              {/* <ControlLabel className={cx(s.landingLabel, "textWhite")}>
                <FormattedMessage {...messages.captionCoverPhoto} />
              </ControlLabel> */}
              <Field
                name="photo"
                component={({ input, meta: { touched, error } }) => {
                  const djsConfig = {
                    acceptedFiles: "image/jpeg,image/png,image/gif",
                    maxFiles: 1,
                    autoProcessQueue: false,
                    previewTemplate: "<div></div>", // Prevents Dropzone from rendering its default thumbnail
                    accept: (file, done) => {
                      const validExtensions = ['.jpg', '.jpeg', '.png', '.gif'];
                      const extension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();

                      if (file.name.split('.').length > 2) {
                        done('File names with multiple extensions are not allowed');
                        return;
                      }

                      if (!validExtensions.includes(extension)) {
                        done('Invalid file extension. Only .jpg, .jpeg, .png, and .gif are allowed');
                        return;
                      }

                      done();
                    }
                  };


                  const componentConfig = {
                    iconFiletypes: [".jpg", ".png", ".gif"],
                    // showFiletypeIcon: true,
                    postUrl: "no-url",
                    dropzoneSelector: ".dropzone",
                    className: "customStyle"
                  };

                  const eventHandlers = {
                    addedfile: (file) => {
                      if (file.size > 2 * 1024 * 1024) {
                        showToaster({
                          messageId: "maxCoverSize",
                          toasterType: "error",
                        });
                        if (this.dropzone && file) {
                          this.dropzone.removeFile(file);
                        }
                        return;
                      }

                      const reader = new FileReader();
                      reader.onload = (e) => {
                        const arr = new Uint8Array(e.target.result).subarray(0, 4);
                        let header = "";
                        for (let i = 0; i < arr.length; i++) {
                          header += arr[i].toString(16);
                        }

                        const validMagicNumbers = [
                          "89504e47", // PNG
                          "ffd8ffe0", // JPEG
                          "ffd8ffe1",
                          "ffd8ffe2",
                          "ffd8ffe3",
                          "ffd8ffe8",
                          "47494638", // GIF
                        ];

                        const isValid = validMagicNumbers.some((magic) =>
                          header.startsWith(magic)
                        );

                        if (!isValid) {
                          showToaster({
                            messageId: "invalidType",
                            toasterType: "error",
                          });
                          if (this.dropzone && file) {
                            this.dropzone.removeFile(file);
                          }
                          return;
                        }

                        const previewReader = new FileReader();
                        previewReader.onloadend = () => {
                          input.onChange(previewReader.result);
                          // Show success message after the image is fully loaded and processed
                          showToaster({
                            messageId: "addBanner",
                            toasterType: "success",
                          });
                        };
                        previewReader.readAsDataURL(file);
                      };


                      const dropzoneEl = document.querySelector(".dropzone");
                      if (dropzoneEl) {
                        dropzoneEl.classList.remove("dz-started");
                      }

                      reader.readAsArrayBuffer(file);
                    },

                    removedfile: () => {
                      input.onChange(null);
                    },
                    init: (dropzone) => {
                      this.dropzone = dropzone;
                    }
                  };

                  return (
                    <div className={cx("listPhotoContainer", "documentUpload")}>
                      <p className={s.documentIcon}><img src={documentIcon} /></p>

                      <div className={s.photoUploadWrapper}>
                        {/* Upload Box Only */}
                        <DropzoneComponent
                          config={componentConfig}
                          eventHandlers={eventHandlers}
                          djsConfig={djsConfig}
                        />
                        {touched && error && (
                          <span className={s.errorMessage}>{error}</span>
                        )}
                      </div>

                      {/* Separate Preview Area (outside the upload box) */}
                      {input.value && (
                        <span className={s.coverPreviewWrapper}>
                          <img
                            src={input.value}
                            alt="Preview"
                            className={s.coverPreview}
                            style={{ maxWidth: 300, borderRadius: 8 }}
                          />
                        </span>
                      )}
                    </div>

                  );

                }}
              />
            </FormGroup>


          </div>
          <FooterButton
            disabled={isDisabled}
            previousPage={previousPage}
            previousPagePath={"photos"}
            type={"submit"}
            formPage={formPage}
            step={step}
          />
        </form>
      </div>
    );
  }
}

Description = reduxForm({
  form: "ListPlaceStep2", // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep2,
  onSubmit: updateStep2,
})(Description);

const selector = formValueSelector("ListPlaceStep2");

const mapState = (state) => ({
  listingFields: state.listingFields.data,
  title: selector(state, "title"),
});

const mapDispatch = {};

export default injectIntl(
  withStyles(s, bt)(connect(mapState, mapDispatch)(Description))
);
